// import { useCallback } from 'react';
import Footer from './components/footer';
import Header from './components/header';
// import { useSiteContext } from './LayoutProvider';

export const DefaultLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    // const { siteState, setSiteState } = useSiteContext();

    // const toggleLanguage = useCallback(() => {
    //     setSiteState(s => ({ ...s, language: s.language === 'en' ? 'es' : 'en' }));
    // }, [setSiteState]);

    return (
        <main>
            <div className="flex flex-col min-h-[100vh]">
                <Header />
                <div>{children}</div>
                {/* <h1 className="text-3xl font-bold underline text-yellow2">Default Layout</h1>
                    <h2>Current Language: {siteState.language}</h2>
                    <button onClick={toggleLanguage}>Toggle Language</button> */}
                <Footer />
            </div>
        </main>
    );
};
